export default __webpack_public_path__ + "static/s3-f218ef8e7fa1750a309f8fcfba332866.jpg";